webpackJsonp([165756320588290],{

/***/ 464:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Razy Technologies"}},"allMarkdownRemark":{"totalCount":1,"edges":[{"node":{"fields":{"slug":"/projects/digital-governmental-solutions/"},"frontmatter":{"title":"Digital Government Solutions"}}}]}},"pathContext":{"tag":"government"}}

/***/ })

});


// WEBPACK FOOTER //
// path---tags-government-a7dda0e8434b90547ee8.js